import React from "react";
import { Link } from "react-router-dom";

function MiscPageLookingFor(props) {
  return (
    <div className="mt-5 text-center">
      <label className="text-muted">
        Are you looking for{" "}
        <Link
          className="text-decoration-none"
          to={props.data.data1.link}
          state={{ title: props.data.data1.title }}
        >
          {props.data.data1.title}
        </Link>
        ,{" "}
        <Link
          className="text-decoration-none"
          to={props.data.data2.link}
          state={{ title: props.data.data2.title }}
        >
          {props.data.data2.title}
        </Link>
        ,{" "}
        <Link
          className="text-decoration-none"
          to={props.data.data3.link}
          state={{ title: props.data.data3.title }}
        >
          {props.data.data3.title}
        </Link>
        ?
      </label>
    </div>
  );
}

export default MiscPageLookingFor;
